import http from "./http";
import type { WorldCityOption } from "../utils/searchWorldLibraryCities";

export type GeonamePlaceDto = WorldCityOption & {
	geonameId?: number;
	timezone?: string;
	featureClass?: string;
	featureCode?: string;
};

/**
 * GET /utility/admin-geoname-places (GeoNamePlaces trên server — cần đã import GeoNames).
 */
export async function searchGeonamePlacesForAdmin(
	query: string,
	opts?: { countryCode?: string; limit?: number; browseMax?: number }
): Promise<GeonamePlaceDto[]> {
	const q = String(query || "").trim();
	const limit = typeof opts?.limit === "number" ? opts.limit : 100;
	const params = new URLSearchParams();
	if (q) params.set("q", q);
	if (opts?.countryCode) params.set("countryCode", opts.countryCode);
	params.set("limit", String(Math.min(500, Math.max(1, limit))));
	if (typeof opts?.browseMax === "number" && opts.browseMax > 0) {
		params.set("browseMax", String(Math.min(5000, opts.browseMax)));
	}
	const { data } = await http.get<{ results: GeonamePlaceDto[] }>(`/utility/admin-geoname-places?${params.toString()}`);
	return Array.isArray(data?.results) ? data.results : [];
}

/**
 * Duyệt top địa điểm theo nước (dân số) khi chưa gõ tìm (ô city).
 */
export async function browseGeonamePlacesByCountry(
	countryCode: string,
	browseMax = 2000
): Promise<GeonamePlaceDto[]> {
	const cc = String(countryCode || "").trim().toUpperCase();
	if (!cc) return [];
	return searchGeonamePlacesForAdmin("", { countryCode: cc, limit: 100, browseMax });
}
